import { Button, Card, Form, Input, Typography, Layout } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { useState } from "react";
import { MEMBER_LOGIN } from "../../services/apiEndPoints";
import axios from "../../services/axiosInstance";
import { useAuth } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { toastSuccess, toastError } from "../../utils/toast";

const { Title, Text } = Typography;
const { Content } = Layout;

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) {
      toastError("Email is required");
      return;
    }

    if (!password) {
      toastError("Password is required");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(MEMBER_LOGIN, {
        memberEmail: email,
        password,
      });

      if (response?.data?.token) {
        localStorage.setItem("token", response.data.token);
        login(response.data.token);
        toastSuccess("Logged in successfully");
        setTimeout(() => navigate("/"), 1000);
      } else {
        toastError("Invalid login response");
      }
    } catch (error: any) {
      toastError(
        error?.response?.data?.message || "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="login-layout">
      {/* Decorative Side */}
      <div className="login-decor">
        <div className="decor-circle decor-1" />
        <div className="decor-circle decor-2" />
        <div className="decor-circle decor-3" />

        <div className="decor-content">
          <div className="decor-logo">
            <img
              src="/logo.png"
              alt="Logo"
              style={{ height: 48, width: 48, objectFit: "contain" }}
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          </div>
          <Title level={2} style={{ color: "#fff", marginBottom: 8 }}>
            Access Warehousing
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: 15 }}>
            Document management made simple
          </Text>
        </div>
      </div>

      {/* Login Form */}
      <Content className="login-content">
        <Card className="login-card" styles={{ body: { padding: "32px 28px" } }}>
          <div style={{ marginBottom: 24 }}>
            <Title level={3} style={{ marginBottom: 4 }}>
              Welcome back
            </Title>
            <Text type="secondary">Sign in to your admin portal</Text>
          </div>

          <Form layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="Email"
              name="memberEmail"
              rules={[
                { required: true, message: "Enter your email" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input
                prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
                placeholder="you@example.com"
                size="large"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Enter your password" }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                placeholder="Enter your password"
                size="large"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 12 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
                style={{ height: 44, fontWeight: 600 }}
              >
                Sign In
              </Button>
            </Form.Item>

            <div style={{ textAlign: "center" }}>
              <Link to="/forget-password">
                <Button type="link" style={{ padding: 0 }}>
                  Forgot your password?
                </Button>
              </Link>
            </div>

            <Text
              type="secondary"
              style={{
                display: "block",
                textAlign: "center",
                marginTop: 24,
                fontSize: 12,
              }}
            >
              &copy; {new Date().getFullYear()} Access Warehousing
            </Text>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
}
